import React, {useEffect, useState} from 'react';
import {ScrollView, StyleSheet, ActivityIndicator, View, Text} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import {apiMasterClin} from '../../../../services/api';
import {SearchInput} from '../../../../components/Interface/Forms/Inputs/SearchInput';
import {Keyboard, TouchableWithoutFeedback} from 'react-native';
import {LinkButton} from '../../../../components/Interface/Forms/Buttons/LinkButton';
import {FilterItem, FilterItemText, FilterItemIcon, FilterItemRow, FilterItemInfo} from './filter-components.styles';

interface Props {
  estado: number;
  cidade?: number;
  onSelectCidade: (value: any) => void;
}

export default function FilterCidadeContent({estado, cidade, onSelectCidade}: Props) {
  const [search, setSearch] = useState('');
  const [cities, setCities] = useState<any[]>([]);
  const [filteredCities, setFilteredCities] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    async function fetchCities() {
      await apiMasterClin
        .get(`/endereco/cidades/${estado}`)
        .then((response: any) => {
          const {data} = response.data;
          if (data && isMounted) {
            setCities(data);
            setLoading(false);
          }
        })
        .catch(() => {
          if (isMounted) setLoading(false);
        });
    }

    if (estado) {
      fetchCities();
    }

    return () => {
      isMounted = false;
    };
  }, [estado]);

  const handleSearchCities = (name: string) => {
    const filter = cities.filter(c =>
      c.nome
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .includes(
          name
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, ''),
        ),
    );
    setFilteredCities(filter);
    setSearch(name);
  };

  const displayCities = search.length > 0 ? filteredCities : cities;

  return (
    <TouchableWithoutFeedback onPress={Keyboard.dismiss}>
      <View style={styles.container}>
        <SearchInput
          placeholder="Buscar cidade"
          value={search}
          autoCapitalize="sentences"
          onChangeText={handleSearchCities}
        />
        <View style={{marginTop: RFValue(16), flexDirection: 'row',}}>
          <LinkButton
            text="Limpar filtro"
            enabled
            action={() => onSelectCidade(undefined)}
          />
        </View>

        {loading ? (
          <ActivityIndicator size="large" style={styles.loader} />
        ) : displayCities.length > 0 ? (
          <ScrollView
            scrollEnabled
            showsVerticalScrollIndicator={false}
            contentContainerStyle={styles.content}>
            {displayCities.map((c, index) => (
              <FilterItem
                key={c.id}
                style={{
                  borderBottomWidth:
                    index === displayCities.length - 1 && displayCities.length > 1 ? 0 : 1,
                }}
                onPress={() => onSelectCidade(c.id)}>
                <FilterItemRow>
                  <FilterItemInfo>
                    <FilterItemText active={c.id === cidade}>{c.nome}</FilterItemText>
                  </FilterItemInfo>
                  <FilterItemIcon name={c.id === cidade ? 'check' : 'chevron-right'} />
                </FilterItemRow>
              </FilterItem>
            ))}
          </ScrollView>
        ) : (
          <View style={styles.emptyState}>
            <Text style={styles.emptyTitle}>
              {estado ? 'Nenhuma cidade encontrada.' : 'Selecione um estado para carregar as cidades.'}
            </Text>
            {estado && <Text style={styles.emptySubtitle}>Tente outro termo de busca.</Text>}
          </View>
        )}
      </View>
    </TouchableWithoutFeedback>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: RFValue(24),
    paddingVertical: RFValue(16),
    maxHeight: '98%',
  },
  content: {
    paddingVertical: RFValue(16),
  },
  loader: {
    marginTop: RFValue(20),
  },
  emptyState: {
    marginTop: RFValue(24),
    paddingHorizontal: RFValue(8),
  },
  emptyTitle: {
    textAlign: 'center',
    color: '#555',
    fontSize: RFValue(12),
    fontWeight: '600',
  },
  emptySubtitle: {
    textAlign: 'center',
    color: '#777',
    fontSize: RFValue(11),
    marginTop: RFValue(4),
  },
});
